import { Chess } from "chess.js";
import { Chessboard } from "react-chessboard";
import { useEffect, useRef, useState } from "react";

const BlunderViewer = ({ pgn, moveData, seletedTab, color }) => {
  console.log(JSON.stringify(moveData), "moveData in blunder viewer")
  console.log(seletedTab, "seletedTab")
  console.log(color, "color")
  const chessRef = useRef(new Chess());
  const [fen, setFen] = useState(chessRef.current.fen());
  const [customArrows, setCustomArrows] = useState([]);

  const pieceMap = {
    wP: "wp",
    wR: "wr",
    wN: "wn",
    wB: "wb",
    wQ: "wq",
    wK: "wk",
    bP: "bp",
    bR: "br",
    bN: "bn",
    bB: "bb",
    bQ: "bq",
    bK: "bk",
  };
  
  const customPieces = Object.fromEntries(
    Object.keys(pieceMap).map((key) => [
      key,
      ({ squareWidth }) => (
        <img
          src={`https://assets-themes.chess.com/image/ejgfv/150/${pieceMap[key]}.png`}
          style={{ width: squareWidth, height: squareWidth }}
          alt=""
        />
      ),
    ])
  );

  useEffect(() => {
    if (!pgn) return;

    if (!moveData) {
      const chess = new Chess();
      chess.loadPgn(pgn);
      setFen(chess.fen());
      setCustomArrows([]);
      return;
    }

    const chess = new Chess();
    chess.loadPgn(pgn);

    const history = chess.history({ verbose: true });
    const plyIndex = moveData.moveNumber - 1;

    chess.reset();

    // ▶️ play moves BEFORE blunder
    for (let i = 0; i < plyIndex && history[i]; i++) {
      chess.move(history[i]);
    }

    chessRef.current = chess;
    setFen(chess.fen());
    setCustomArrows([]);

    const blunderFrom = moveData.move.slice(0, 2);
    const blunderTo = moveData.move.slice(2, 4);

    const bestFrom = moveData.bestMove.slice(0, 2);
    const bestTo = moveData.bestMove.slice(2, 4);

    const replyFrom = moveData.opponentBestReply?.slice(0, 2);
    const replyTo = moveData.opponentBestReply?.slice(2, 4);


    //  Step 1 — Show BLUNDER
    const blunderTimer = setTimeout(() => {
      chess.move(moveData.san);
      setFen(chess.fen());

      setCustomArrows([
        [blunderFrom, blunderTo, "#ff0000"]
      ]);
    }, 700);

    //  Step 2 — Show BEST MOVE (without removing red)
    const bestMoveTimer = setTimeout(() => {
      // chess.undo();
      // chess.move({ from: bestFrom, to: bestTo });
      setFen(chess.fen());

      setCustomArrows(prev => [
        ...prev, // keep red arrow
        [bestFrom, bestTo, "#00c853"]
      ]);
    }, 1600);


    //  Step 3 — Show OPPONENT BEST REPLY (orange)
    const opponentReplyTimer = setTimeout(() => {
      if (!moveData.opponentBestReply) return;

      // chess.move({
      //   from: replyFrom,
      //   to: replyTo,
      // });

      setFen(chess.fen());

      setCustomArrows(prev => [
        ...prev, // keep red + green
        [replyFrom, replyTo, "#ff9800"] // orange
      ]);
    }, 2400);

    return () => {
      clearTimeout(blunderTimer);
      clearTimeout(bestMoveTimer);
      clearTimeout(opponentReplyTimer);
    };
  }, [pgn, moveData]);

  const isFullGame = seletedTab === "Full Game";

  const boardOrientation = color?.toLowerCase()
  return (
    <div style={{ width: 420 }}>
      {/* <p>🟠 Opponent Best : <b>{moveData.opponentBestReply}</b></p> */}
      <Chessboard
        position={fen}
        boardWidth={500}
        customArrows={customArrows}
        animationDuration={300}
        boardOrientation={boardOrientation}
        customLightSquareStyle={{ backgroundColor: "#eeed2" }}
        customDarkSquareStyle={{ backgroundColor: "#81b64c" }}
        customPieces={customPieces}

      />

      {/* <div style={{ marginTop: 12 }}>
        <p>
          🔴 Move : <b>{moveData.san}</b>{" "}
          {moveData.moveType !== "Best Move" && (
            <span>({moveData.moveType})</span>
          )}
        </p>
        <p>✅ Best: <b>{moveData.bestMove}</b></p>


      </div> */}
    </div>
  );
};

export default BlunderViewer;
